/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import { SET_PRICE_DATA_RECENT_AVERAGES, SET_PRICE_DATA_YOY_CHANGE } from '../constants/index'

export const priceDataReducer = combineReducers({
  recentAverages: handleAction(SET_PRICE_DATA_RECENT_AVERAGES, payloadReducer, []),
  yoyChange: handleAction(SET_PRICE_DATA_YOY_CHANGE, payloadReducer, null),
})
